interface UIStoreLike {
  closeFeedback(): void;
}

function uiStore(): UIStoreLike {
  return (window as unknown as { Alpine: { store(name: string): UIStoreLike } }).Alpine.store("ui");
}

interface FeedbackForm {
  mostUseful: string;
  aircraftCount: string;
  activeStudents: string;
  instructors: string;
  currentTool: string;
  urgency: string;
  note: string;
}

export function feedbackAlpine() {
  return {
    step: 1 as 1 | 2 | 3,
    busy: false,
    form: {
      mostUseful: "",
      aircraftCount: "",
      activeStudents: "",
      instructors: "",
      currentTool: "",
      urgency: "",
      note: "",
    } as FeedbackForm,
    async submit() {
      this.busy = true;
      try {
        const res = await fetch("/api/feedback", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.form),
        });
        if (!res.ok && res.status !== 0) {
          console.warn("[Runway Sync] /api/feedback returned", res.status);
        }
      } catch (err) {
        console.warn("[Runway Sync] /api/feedback failed:", err);
      } finally {
        this.busy = false;
        this.step = 3;
        try {
          const fb = JSON.parse(localStorage.getItem("runway-sync.feedback") || "[]");
          fb.push({ ...this.form, ts: new Date().toISOString() });
          localStorage.setItem("runway-sync.feedback", JSON.stringify(fb));
        } catch (err) {
          console.warn("[Runway Sync] localStorage write failed:", err);
        }
      }
    },
    successMessage(): string {
      const u = this.form.urgency;
      if (u === "Urgent" || u === "This month") {
        return `You marked this as <strong>${u.toLowerCase()}</strong>. We'll reach out within the next business day to set up a working session.`;
      }
      return "We'll keep you on the list and follow up when there's something worth your time.";
    },
    close() {
      uiStore().closeFeedback();
    },
  };
}
